import { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { fetchCustomerServiceChannelMode } from '@formosa/shared/utils/customerServiceEntry';
import { useAuth } from '../auth/AuthContext';

const ImFeatureContext = createContext(null);

const DEFAULT = {
  chatEnabled: false,
  supportMode: 'OFF',
  channelMode: 'OFF',
  formosaImEnabled: false,
  thirdPartyCmsEnabled: false,
  loaded: false,
};

/**
 * CS20：會員端聊天／客服總開關（來自 GET channel-mode）。
 * 失敗偏向 OFF／chatEnabled=false。
 */
export function ImFeatureProvider({ children }) {
  const { isAuthenticated } = useAuth();
  const [flags, setFlags] = useState(DEFAULT);

  const refresh = useCallback(async () => {
    const mode = await fetchCustomerServiceChannelMode();
    setFlags({
      chatEnabled: !!mode.chatEnabled,
      supportMode: mode.supportMode || mode.channelMode || 'OFF',
      channelMode: mode.channelMode || mode.supportMode || 'OFF',
      formosaImEnabled: !!mode.formosaImEnabled,
      thirdPartyCmsEnabled: !!mode.thirdPartyCmsEnabled,
      loaded: true,
    });
  }, []);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const mode = await fetchCustomerServiceChannelMode();
      if (!cancelled) {
        setFlags({
          chatEnabled: !!mode.chatEnabled,
          supportMode: mode.supportMode || mode.channelMode || 'OFF',
          channelMode: mode.channelMode || mode.supportMode || 'OFF',
          formosaImEnabled: !!mode.formosaImEnabled,
          thirdPartyCmsEnabled: !!mode.thirdPartyCmsEnabled,
          loaded: true,
        });
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [isAuthenticated]);

  const value = useMemo(() => ({ ...flags, refresh }), [flags, refresh]);

  return <ImFeatureContext.Provider value={value}>{children}</ImFeatureContext.Provider>;
}

export function useImFeature() {
  const ctx = useContext(ImFeatureContext);
  if (!ctx) {
    throw new Error('useImFeature must be used within ImFeatureProvider');
  }
  return ctx;
}
